import { defineStore } from 'pinia'
import { ref } from 'vue'
import { CtmsControllerApi } from "@/http/apis/CtmsControllerApi";

const api = new CtmsControllerApi()

export const useDictStore = defineStore(
  'dict',
  () => {
    const ctmsOptions = ref<any[]>([])
    let ctmsRequest: Promise<any[]> | null = null

    const setCtmsOptions = (list: any[]) => {
      ctmsOptions.value = list || []
    }

    const fetchCtmsOptions = async (force = false) => {
      // 强制刷新进行中时，其他页面复用同一个请求并等待最新数据。
      if (ctmsRequest) return ctmsRequest
      if (!force && ctmsOptions.value.length) return ctmsOptions.value

      ctmsRequest = api.ctmsItemOptionListGet()
        .then((res) => {
          setCtmsOptions(res.data || [])
          return ctmsOptions.value
        })
        .catch((e) => {
          console.error('获取通关类目失败', e)
          return ctmsOptions.value
        })
        .finally(() => {
          ctmsRequest = null
        })

      return ctmsRequest
    }

    return {
      ctmsOptions,
      setCtmsOptions,
      fetchCtmsOptions
    }
  },
  {
    persist: true // ✅ 自动缓存（你已经装了插件）
  }
)
